<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/NUtp5K/tc-custom/9783956768088.jpg?1704761761157" alt="This image is the cover for the book Nach Sibirien mit hunderttausend Deutschen, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Nach Sibirien mit hunderttausend Deutschen, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Kurt Aram, Pseudonym für Hans Fischer (* 28. Januar 1869 in Lennep; † 10. Juli 1934 in Berlin) war ein deutscher Journalist und Schriftsteller, der unter diesem Namen schrieb. Bis zu seiner Amtsniederlegung 1900 war er unter seinem bürgerlichen Namen Pfarrer in Herborn. Er war Redakteur beim Berliner Tageblatt, Mitherausgeber der Literaturzeitschrift März und verfasste eine Reihe von Romanen, die allgemein zur Unterhaltungsliteratur gezählt werden. (Auszug aus Wikipedia)</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Kurt Aram
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?4e64af72